import React, { useEffect, useState } from "react";
import "./ProjectGallery.css";
import type { ProjectTileType } from "types";
import ProjectTile from "Pieces/ProjectTile/ProjectTile";
import { Flex, useBreakpointValue } from "@chakra-ui/react";

interface Props {
  projects: ProjectTileType[];
  limit?: number;
}

const ProjectGallery: React.FC<Props> = ({ projects, limit }) => {
  const [tiles, setTiles] = useState<ProjectTileType[]>([]);
  const columns = useBreakpointValue(
    {
      base: 1,
      sm: 2,
      md: 3,
    },
    {
      fallback: "base",
    }
  );
  const remainder = columns! - (tiles.length % columns!);

  useEffect(() => {
    if (limit) {
      setTiles(projects.slice(0, limit));
    } else {
      setTiles(projects);
    }
  }, [limit, projects]);

  return (
    <Flex flexWrap="wrap" width="100%" borderBottom="1px solid black">
      {tiles.map((project, index) => (
        <ProjectTile project={project} key={project.key} index={index} />
      ))}
      {Array.from({ length: remainder }).map(() => (
        <Flex
          width={{ base: "100%", sm: "50%", md: `${100 / 3}%` }}
          borderRight="1px solid black"
          borderTop="1px solid black"
        />
      ))}
    </Flex>
  );
};

export default ProjectGallery;
